//@flow
import React from 'react';

import {makeStyles, TableCell, Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import {useProductContext} from '../../../context';

const useStyles = makeStyles(theme => ({
  infoText: {
    color: colors.grey900,
    opacity: 0.4,
    fontWeight: 500,
    textAlign: 'center',
    fontSize: '.9rem',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    width: '100%',
    lineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default function PromotionCell() {
  const classes = useStyles();
  const [promotions] = useProductContext(product => product.promotions);

  return (
    <TableCell align="right">
      <Typography className={classes.infoText}>{promotions}</Typography>
    </TableCell>
  );
}
